<form class="providerForm" [formGroup]="providerForm" (ngSubmit)="providerDetailsSubmit()">
  <div class="row main-home py-0">
    <div class="col-md-12">
      <p role="heading" aria-level="1">Please enter any information you have regarding the {{title}}</p>
    </div>
  </div>
  @if (isNameRequired || isRequiredIdLabelVisible) {
    <div class="row main-home">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
        @if (isNameRequired) {
          <span class="col-form-label" style="font-size:14px;">
            Organization Name or First & Last Name Required
          </span>
        }
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
        @if (isRequiredIdLabelVisible) {
          <span class="col-form-label" style="font-size:14px;">
            {{requiredIdFormat}}
          </span>
        }
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
      </div>
    </div>
  }
  <div class="row main-home" role="form">
    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
      <form [formGroup]="providerFormPart1">
        @if (isformloaded) {
          <app-json-form [controlsData]="providerFormData1.controls" [formData]="providerFormPart1"
          (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
        }
      </form>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
      <form [formGroup]="providerFormPart2">
        @if (isformloaded) {
          <app-json-form [controlsData]="providerFormData2.controls" [formData]="providerFormPart2"
          (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
        }
      </form>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
      <form [formGroup]="providerFormPart3">
        @if (isformloaded) {
          <app-json-form [controlsData]="providerFormData3.controls" [formData]="providerFormPart3"
          (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
        }
      </form>
    </div>

  </div>
</form>